// solanaProvider.ts

import EventEmitter from 'events'
import { getDefaultStore } from 'jotai'
import { AnchorProvider } from '@coral-xyz/anchor'
import NodeWallet from '@coral-xyz/anchor/dist/cjs/nodewallet'
import { Connection, Keypair } from '@solana/web3.js'

// import { STORAGE_KEY } from '@/constants/common'
import {
  DEFAULT_RPC_ENDPOINT,
  RPCEndpointKey,
  SUPPORT_RPC_ENDPOINT
} from '@/constants/settings'
// import { rpcEndpointAtom } from '@/stores/settings'
import { rpcSettingAtom } from '@/stores/settings'

type RpcEndpoint = {
  url: string
  ws?: string
  name?: string
  key?: string
  mev?: true
}

enum ProviderFactoryEvents {
  ON_ERROR = 'onError',
  ON_RECONNECT = 'onReconnect',
  ON_CHANGE = 'onChange'
}

class ProviderFactory {
  // private _rpcEndpoints: RpcEndpoint[]
  private _currentRpc: RpcEndpoint
  private _connection: Connection
  private _wallet: NodeWallet
  private _provider: AnchorProvider
  private _event: EventEmitter
  private _checkInterval: any = null
  private _checkTimer: any

  constructor(options: {
    endpoint: RpcEndpoint
    checkInterval?: number
    endpointOptional?: RpcEndpoint[]
  }) {
    this._event = new EventEmitter()
    // this._rpcEndpoints = options.endpointOptional || []
    this._checkInterval = options.checkInterval
    this._currentRpc = options.endpoint
    this._wallet = new NodeWallet(Keypair.generate())
    this._connection = this.createConnection(this._currentRpc)
    this._provider = new AnchorProvider(this._connection, this._wallet, {
      commitment: 'finalized'
    })

    // this.startConnectionChecker()
  }

  private createConnection(endpoint: RpcEndpoint) {
    return new Connection(endpoint.url, {
      commitment: 'confirmed',
      wsEndpoint: endpoint.ws || undefined
    })
  }

  // private startConnectionChecker() {
  //   // 每 30 秒检测一次 connection 是否存活（slot是否有变化）
  //   if (this._checkTimer) {
  //     clearInterval(this._checkTimer)
  //   }
  //   this._checkTimer = setInterval(async () => {
  //     try {
  //       const slot = await this._connection.getSlot()
  //       // console.log('Connection healthy, current slot:', slot)
  //     } catch (err) {
  //       // console.error('Connection failed, trying fallback RPC...')
  //       this._event.emit(ProviderFactoryEvents.ON_ERROR, err)
  //       // this.useBestRpc()
  //     }
  //   }, this._checkInterval)
  // }

  // private async useBestRpc() {
  //   // 轮询最快可用的RPC
  //   for (const endpoint of this._rpcEndpoints) {
  //     try {
  //       const conn = this.createConnection(endpoint)
  //       const slot = await conn.getSlot({ commitment: 'processed' })
  //       if (slot > 0) {
  //         this.switchRpc(endpoint)
  //         this._event.emit(ProviderEvents.ON_RECONNECT, endpoint)
  //         return
  //       }
  //     } catch (err) {
  //       continue
  //     }
  //   }
  //   console.error('No available RPC endpoints found!')
  // }

  public switchRpc(newRpc: RpcEndpoint) {
    console.log('Switching RPC endpoint to:', newRpc.url)
    this._currentRpc = newRpc
    this._connection = this.createConnection(newRpc)
    this._provider = new AnchorProvider(this._connection, this._wallet, {
      commitment: 'finalized'
    })
    this._event.emit(ProviderFactoryEvents.ON_CHANGE, newRpc)
  }

  public resetWallet() {
    console.log('Resetting wallet')
    this._wallet = new NodeWallet(Keypair.generate())
    this._provider = new AnchorProvider(this._connection, this._wallet, {
      commitment: 'finalized'
    })
  }

  public destroy() {
    if (this._checkTimer) {
      clearInterval(this._checkTimer)
    }
    // this._event.removeAllListeners()
    // this._provider.disconnect()
  }

  public get connection() {
    return this._connection
  }

  public get wallet() {
    return this._wallet
  }

  public get provider() {
    return this._provider
  }

  public get rpcEndpoint() {
    return this._currentRpc
  }

  public get event() {
    return this._event
  }
}

// 实例化ProviderFactory
// const rpcEndpointStore = getDefaultStore().get(rpcEndpointAtom)
// const rpcSettingStore = window.localStorage.getItem(STORAGE_KEY.RPC_SETTING)
let rpcEndpoint
try {
  // const data = JSON.parse(rpcSettingStore || '')
  const data = getDefaultStore().get(rpcSettingAtom)
  rpcEndpoint = SUPPORT_RPC_ENDPOINT.find((item) => item.key === data?.rpcKey)
  if (rpcEndpoint?.key === RPCEndpointKey.Custom) {
    rpcEndpoint.url = data.rpcUrl
  }
} catch {
  rpcEndpoint = undefined
}
if (!rpcEndpoint?.url) {
  rpcEndpoint = DEFAULT_RPC_ENDPOINT
}

const solanaProvider = new ProviderFactory({
  endpoint: rpcEndpoint as RpcEndpoint
})

export {
  ProviderFactory,
  ProviderFactoryEvents,
  type RpcEndpoint,
  solanaProvider
}
